import { api } from '../axiosClient';
import type { ConfigurationResponse } from './configuration.types';

const CONFIGURATION_PATH = '/Configuration';

export const getConfiguration = (): Promise<ConfigurationResponse> => {
  return api.get(CONFIGURATION_PATH);
};
